import { useQuery } from "@tanstack/react-query";
import { RocketLaunchIcon, SpinnerGapIcon } from "@phosphor-icons/react";
import { fetchEarlyGambles } from "../lib/api";
import { useChain } from "../context/ChainContext";
import { CoinTable } from "./CoinTable";
import { filterByAge, ageLabel } from "./AgeFilter";
import { useGlobalAge } from "../context/AgeFilterContext";

export const EarlyGambles = () => {
  const { chain } = useChain();
  const { age } = useGlobalAge();
  const { data, isLoading } = useQuery({
    queryKey: ["earlyGambles", chain],
    queryFn: () => fetchEarlyGambles(chain),
    refetchInterval: 90000,
    placeholderData: (p) => p,
  });
  const allCoins = data?.coins || [];
  const coins = filterByAge(allCoins, age);

  return (
    <div className="space-y-3 border-t border-white/10 pt-8" data-testid="early-gambles">
      <div className="flex items-center gap-2.5">
        <RocketLaunchIcon size={24} weight="fill" className="text-warn" />
        <h2 className="font-heading font-black text-2xl sm:text-3xl tracking-tighter leading-none">
          EARLY <span className="text-warn">GAMBLES</span>
        </h2>
      </div>
      <p className="text-sm text-muted-foreground max-w-2xl">
        Fresh, tiny plays the boosted Radar misses — young (&lt;36h), $15k–$500k mcap, already showing real volume.
        This is where the 16x's hide. <span className="text-warn font-semibold">Extreme risk — most go to zero.</span> Always DYOR.
      </p>
      {isLoading ? (
        <div className="flex justify-center py-14"><SpinnerGapIcon size={28} className="animate-spin text-warn" /></div>
      ) : allCoins.length === 0 ? (
        <div className="border border-white/10 bg-card py-14 text-center text-muted-foreground font-mono text-sm">
          No early gambles clearing the bar right now — check back soon.
        </div>
      ) : coins.length === 0 ? (
        <div className="border border-white/10 bg-card py-14 text-center text-muted-foreground font-mono text-sm">
          No early gambles under {ageLabel(age)} old right now — widen the age filter at the top.
        </div>
      ) : (
        <>
          <div className="text-xs font-mono text-muted-foreground">{coins.length} fresh gambles 🎲</div>
          <CoinTable coins={coins} sort="score" order="desc" onSort={() => {}} />
        </>
      )}
    </div>
  );
};
